"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _ArrowForwardIos = _interopRequireDefault(require("@material-ui/icons/ArrowForwardIos"));

var _useProductDetailCertificateComponent = _interopRequireDefault(require("../../../hooks/useProductDetailCertificateComponent"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex'
    },
    description: (0, _defineProperty2.default)({
      width: '100%',
      fontWeight: 400,
      fontSize: 16,
      textAlign: 'justify',
      marginRight: 0,
      paddingRight: theme.spacing(2)
    }, theme.breakpoints.down('sm'), {
      textAlign: 'left'
    }),
    descriptionContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      justifyContent: 'flex-start'
    },
    allDescription: (0, _extends2.default)({}, theme.typography.body1, {
      textDecoration: 'none',
      color: theme.palette.secondary.main,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      cursor: 'pointer',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    }),
    icon: {
      marginLeft: theme.spacing(0.5),
      width: 16,
      height: 16,
      fill: theme.palette.secondary.main
    }
  };
}, {
  name: 'ProductDetailDescription'
});

function ProductDetailDescription(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      mobile = _ref.mobile,
      product = _ref.product,
      renderToGridArea = _ref.renderToGridArea,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "mobile", "product", "renderToGridArea"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var description = t(product.description);
  var text = description.length > 250 ? "".concat(description.slice(0, 250), "...") : description;
  var ProductDetailCertificate = (0, _useProductDetailCertificateComponent.default)();
  return product.description ? /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    renderToGridArea: renderToGridArea
  }), mobile && ProductDetailCertificate && /*#__PURE__*/_react.default.createElement(ProductDetailCertificate, null), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.descriptionContainer
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.description
  }, text), /*#__PURE__*/_react.default.createElement("a", {
    href: "#description",
    className: classes.allDescription
  }, t('productDetailPage/allDescription'), /*#__PURE__*/_react.default.createElement(_ArrowForwardIos.default, {
    className: classes.icon
  })))) : null;
}

process.env.NODE_ENV !== "production" ? ProductDetailDescription.propTypes = {
  classes: _propTypes.default.shape({
    allDescription: _propTypes.default.string,
    description: _propTypes.default.string,
    descriptionContainer: _propTypes.default.string,
    icon: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  mobile: _propTypes.default.bool,
  product: _propTypes.default.shape({
    description: _propTypes.default.arrayOf(_propTypes.default.shape({
      language: _propTypes.default.string,
      text: _propTypes.default.string
    }))
  }),
  renderToGridArea: _propTypes.default.string
} : void 0;
ProductDetailDescription.defaultProps = {
  classes: undefined,
  className: undefined,
  mobile: false,
  product: undefined,
  renderToGridArea: 'description'
};
var _default = ProductDetailDescription;
exports.default = _default;